
@if(!status.error) {
   <div @fadeIn class="t-status-message flex items-center w-full text-black transition-opacity ease-in duration-700 opacity-100" [ngClass]="'t-status-message-' + status" role="alert" *transloco="let t">
      @if(shouldShowLoader) {
         <app-loader height="16px" [showAria]="false"></app-loader>
      }
      <p class="t-status-message-text inline text-base">{{t(status.text)}}</p>
   </div>
}
@else {
   <div @fadeIn class="w-full my-2 p-4 bg-cdra-blue-dark-100 border border-cdra-blue-light-300 rounded-md" [ngClass]="'t-status-message-' + status" role="alert" *transloco="let t">
      @if(status.type === 'noresults') {
         <p class="t-status-noresults-text">{{t(status.text)}}</p>
         <h3 class="font-bold my-2">{{ t('status.suggestions.title') }}</h3>
         <ul class="list-disc list-inside">
            <li>{{ t('status.noresults.suggestion.tryrephrasing') }}</li>
            <li>{{ t('status.noresults.suggestion.checkspelling') }}</li>
            <li>{{ t('status.noresults.suggestion.askdifferent') }}</li>
         </ul>
      }
      @else if(status.type === 'unsupported') {
         <p class="t-status-unsupported-text">{{t(status.text)}}</p>
         <h3 class="font-bold my-2">{{ t('status.suggestions.title') }}</h3>
         <ul class="list-disc list-inside">
            <li>{{ t('status.unsupported.suggestion.askdifferent') }}</li>
            <li>{{ t('status.unsupported.suggestion.rephrase') }}</li>
         </ul>
      }
      @else if(status.type === 'quotalimit') {
         <p class="t-status-quotalimit-text inline text-lg">{{t(status.text)}}</p>
      }
      @else {
         <p class="t-message-error-text">{{t(status.text)}}</p>
         <h3 class="font-bold my-2">{{ t('status.suggestions.title') }}</h3>
         <ul class="list-disc list-inside">
            <li>{{ t('status.error.suggestion.retry') }}</li>
            <li>{{ t('status.error.suggestion.contactlibrarian') }}</li>
         </ul>
         <div class="self-end mt-4">
            <app-action-bar [qanda]="qanda"></app-action-bar>
         </div>
      }
   </div>
}